import { render, staticRenderFns } from "./DashboardMobileCarousel.vue?vue&type=template&id=10456f83&"
import script from "./DashboardMobileCarousel.vue?vue&type=script&lang=ts&"
export * from "./DashboardMobileCarousel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports